export default __webpack_public_path__ + "static/media/hero-caro-mbl-new-4.f202ce34.png";